import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { createBaseQuery, post } from '../../utils/helpers';

const manageAgentApi = createApi({
  reducerPath: 'manageAgent',
  tagTypes: [],
  baseQuery: createBaseQuery('/blender/manageresource'),
  endpoints: (builder) => ({
    pushAgentToIdle: builder.mutation<void, string>({
      query: (agentId) => post(`/resources/${agentId}/activate`, {}),
    }),
    pushAgentToBreak: builder.mutation<void, { agentId: string, breakName: string }>({
      query: ({ agentId, breakName }) => post(`/resources/${agentId}/break/${breakName}`, {}),
    }),
    pushAgentToLoggedOut: builder.mutation<void, string>({
      query: (agentId) => post(`/resources/${agentId}/logout`, {}),
    }),
  }),
});

export default manageAgentApi;

export const {
  usePushAgentToIdleMutation,
  usePushAgentToBreakMutation,
  usePushAgentToLoggedOutMutation,
} = manageAgentApi;